import { useEffect, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { RECRUITERS_REVENUE_TRACKER_SUMMARY } from "../../../../config/config";
import { months } from "../../../../utils/time.date.utlis";
import { Helmet } from "react-helmet";
import logo from './../../../../assets/image/logo.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

interface quarterMonthProps {
    month : number;
    percentage_data : {
        recruiter_name : string;
        revenue : number;
        offer_accepted : number;
        for_offer : number;
        total : number;
    }[];
}

interface revenueTrackerSummaryProps {
    quarter_month : quarterMonthProps[];
    summary : { 
        recuiter_name : string; 
        revenue : number;
        offer_accepted : number;
        for_offer : number;
    }[];
    annual_summary : {
        recuiter_name : string; 
        revenue : number;
        offer_accepted : number;
        for_offer : number;
    }[];
}

const RevenueMovement = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();
    const [year, setYear] = useState<number>(currentYear);
    const [revenueSummary, setRevenueSummary] = useState<revenueTrackerSummaryProps | null>(null);
    const [selectedQuarter, setSelectedQuarter] = useState<number>(Math.floor(currentMonth / 3) + 1);

    const incrementYear = () => { 
        setYear(prevYear => prevYear + 1)
    };

    const decrementYear = () => {
        setYear(prevYear => prevYear - 1)
    };

    useEffect(()=>{
        const handleRevenueSummary = async() => {
            try{
                const rev_summary = await api.get(
                    RECRUITERS_REVENUE_TRACKER_SUMMARY+selectedQuarter+'/'+year, {
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const rev_data = rev_summary.data as revenueTrackerSummaryProps;
                setRevenueSummary(rev_data);
            }catch(e){}
        }
        handleRevenueSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedQuarter, year]);

    return(
        <div className="p-4 py-8 h-screen bg-gray-100">
            <Helmet>
                <title>Revenue Summary Tracker</title>
            </Helmet>
            <div className="flex items-center mb-2">
                <div>
                    <h1 className="font-semibold text-gray-700 text-xl">Revenue Movement</h1>
                </div>
                <div className='logo-container ms-auto'>
                    <img src={logo} className='side-bar-logo' alt="VCC Link Logo" />
                </div>
            </div>
            {/* Card container */}
            <div className="flex flex-col w-full bg-gray-300 rounded p-4">
                
                <div className="flex w-full mb-4">
                    <div>
                        <h2>Data Legend:</h2>
                        <div className="flex gap-2">
                            <div className="bg-orange-500 w-32 shadow rounded text-center">Revenue</div>
                            <div className="bg-green-500 w-32 shadow rounded text-center">Offer accepted</div>
                            <div className="bg-yellow-400 w-32 shadow rounded text-center">For offer</div>
                        </div>
                    </div>
                    <div className="ms-auto flex items-center justify-center gap-6">
                        <div className="flex gap-4 text-xl text-gray-700">
                            <div>
                                <button className="hover:text-orange-500" onClick={decrementYear}>
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                </button>
                            </div>
                            <div>
                                {year ? year : currentYear}
                            </div>
                            <div>
                                <button className="hover:text-orange-500" onClick={incrementYear}>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </button>
                            </div>
                        </div>
                        <div>
                            <select className="text-box" onChange={(e)=>{
                                    setRevenueSummary(null)
                                    setSelectedQuarter(parseInt(e.currentTarget.value))
                                }}>
                                <option selected={selectedQuarter === 1 ? true : false} value="1">Quarter 1</option>
                                <option selected={selectedQuarter === 2 ? true : false} value="2">Quarter 2</option>
                                <option selected={selectedQuarter === 3 ? true : false} value="3">Quarter 3</option>
                                <option selected={selectedQuarter === 4 ? true : false} value="4">Quarter 4</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="flex w-full gap-4">
                    {revenueSummary ? revenueSummary.quarter_month.map(month => (
                        <div className="bg-cyan-700 w-full p-4 rounded-lg">
                            <div className="w-full px-12">
                                <div className="bg-white rounded-xl text-center uppercase font-bold">
                                    <h2>{months[month.month - 1]}</h2>
                                </div>
                            </div>
                            <div className="flex flex-col gap-2 py-4">
                                {month.percentage_data.map(data => (
                                    <div>
                                        <div className="flex items-center px-2">
                                            <div>
                                                <h3 className="text-white">{data.recruiter_name}</h3>
                                            </div>
                                            <div className="ms-auto">
                                                <h3 className="text-white">{data.total}%</h3>
                                            </div>
                                        </div>
                                        <div className="w-full flex rounded-lg bg-white p-1">
                                            <div className="bg-orange-500 rounded-lg text-center" style={{width: `${data.revenue}%`}}>{data.revenue}%</div>
                                            {data.offer_accepted > 0 && (<div className="bg-green-500 rounded-lg text-center" style={{width: `${data.offer_accepted}%`}}>{data.offer_accepted}%</div>)}
                                            {data.for_offer > 0 && (<div className="bg-yellow-400 rounded-lg text-center" style={{width: `${data.for_offer}%`}}>{data.for_offer}%</div>)}
                                        </div>
                                    </div>
                                ))}
                                
                            </div>
                        </div>
                    )) : Array.from({length : 3}).map((_, index) => (
                        <div className="bg-gray-400 w-full p-4 rounded-lg animate-pulse cursor-progress">
                            <div className="w-full px-12">
                                <div className="bg-gray-300 p-4">
                                </div>
                            </div>
                            <div className="flex flex-col gap-2 py-4">
                                <div>
                                    <div className="bg-gray-300 w-28 p-2 my-1"></div>
                                    <div className="w-full bg-gray-300 p-2 py-3"></div>
                                </div>
                                <div>
                                    <div className="bg-gray-300 w-28 p-2 my-1"></div>
                                    <div className="w-full bg-gray-300 p-2 py-3"></div>
                                </div>
                                <div>
                                    <div className="bg-gray-300 w-28 p-2 my-1"></div>
                                    <div className="w-full bg-gray-300 p-2 py-3"></div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>

            </div>
            {/* ---- Card Container */}
            {revenueSummary ? (
                <div className="flex w-full my-4">
                    <div className="bg-cyan-700 w-full shadow-lg rounded-lg p-2">
                        <div className="w-full px-24">
                            <div className="bg-white rounded-xl text-center uppercase font-bold">
                                <h2>Total Revenue vs. Target ({revenueSummary ? months[revenueSummary?.quarter_month[0].month - 1] : 'NA'} - {revenueSummary ? months[revenueSummary?.quarter_month[2].month - 1] : 'NA'} {year})</h2>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2 py-4">
                            {revenueSummary.summary.map(summary => (
                                <div>
                                    <div className="flex items-center px-4">
                                        <div>
                                            <h3 className="text-white">{summary.recuiter_name}</h3>
                                        </div>
                                        <div className="ms-auto">
                                            <h3 className="text-white">{summary.revenue + summary.offer_accepted + summary.for_offer}%</h3>
                                        </div>
                                    </div>
                                    <div className="w-full flex rounded-lg bg-white p-1">
                                        <div className="bg-orange-500 rounded-lg text-center" style={{width: `${summary.revenue}%`}}>{summary.revenue}%</div>
                                        {summary.offer_accepted > 0 && (<div className="bg-green-500 rounded-lg text-center" style={{width: `${summary.offer_accepted}%`}}>{summary.offer_accepted}%</div>)}
                                        {summary.for_offer > 0 && (<div className="bg-yellow-400 rounded-lg text-center" style={{width: `${summary.for_offer}%`}}>{summary.for_offer}%</div>)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex w-full my-4 animate-pulse cursor-progress">
                    <div className="bg-gray-400 w-full rounded-lg p-2">
                        <div className="w-full px-24">
                            <div className="bg-gray-300"></div>
                        </div>
                        <div className="flex flex-col gap-2 py-4">
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {revenueSummary ? (
                <div className="flex w-full my-4">
                    <div className="bg-cyan-700 w-full shadow-lg rounded-lg p-2">
                        <div className="w-full px-24">
                            <div className="bg-white rounded-xl text-center uppercase font-bold">
                                <h2>Total Revenue vs. Target {year}</h2>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2 py-4">
                            {revenueSummary.annual_summary.map(summary => (
                                <div>
                                    <div className="flex items-center px-4">
                                        <div>
                                            <h3 className="text-white">{summary.recuiter_name}</h3>
                                        </div>
                                        <div className="ms-auto">
                                            <h3 className="text-white">{summary.revenue + summary.offer_accepted + summary.for_offer}%</h3>
                                        </div>
                                    </div>
                                    <div className="w-full flex rounded-lg bg-white p-1">
                                        <div className="bg-orange-500 rounded-lg text-center" style={{width: `${summary.revenue}%`}}>{summary.revenue}%</div>
                                        {summary.offer_accepted > 0 && (<div className="bg-green-500 rounded-lg text-center" style={{width: `${summary.offer_accepted}%`}}>{summary.offer_accepted}%</div>)}
                                        {summary.for_offer > 0 && (<div className="bg-yellow-400 rounded-lg text-center" style={{width: `${summary.for_offer}%`}}>{summary.for_offer}%</div>)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex w-full my-4 animate-pulse cursor-progress">
                    <div className="bg-gray-400 w-full rounded-lg p-2">
                        <div className="w-full px-24">
                            <div className="bg-gray-300"></div>
                        </div>
                        <div className="flex flex-col gap-2 py-4">
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                            <div>
                                <div className="bg-gray-300 p-2 my-2 w-24"></div>
                                <div className="w-full bg-gray-300 p-2 py-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default RevenueMovement;